<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
      <h2 style="color:white">{{selectedContentType}} toevoegen</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeAddNewsDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert
      class="ma-0 pa-2"
      v-if="feedback"
      :value="true"
      type="warning"
    >
    {{ feedback }} 
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-select
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        :item-color="companyPrimaryColor"
        v-model="newNews.type"
        :items="newsTypes"
        label="Type nieuws"
        item-text="name"
        item-value="id"
        required
        :rules="requiredRules"
      ></v-select>

      <v-select
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        :item-color="companyPrimaryColor"
        style="margin: 15px 0;"
        v-model="newNews.showTo"
        :items="showTo"
        label="Selecteer wie dit bericht kan zien"
        item-text="name"
        item-value="id"
        prepend-inner-icon="visibility"
      ></v-select>


      <v-text-field
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        label="Titel"
        v-model="newNews.title"
        :rules="requiredRules"
        required
        :readonly="update"
        :disable="update"
      ></v-text-field>

      <v-text-field
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        v-if="newNews.type == 'update'"
        label="Versienummer"
        v-model="newNews.version"
        :rules="requiredRules"
        required
        v-on:input="createTitle()"
      ></v-text-field>

      <v-container v-if="newNews.type == 'update'" grid-list-md fluid class="pa-1" style="background-color: #eee; margin: 15px 0;">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex md6>
            <span style="font-size: 16px; font-weight: bold;">Versienummering Policy</span>
          </v-flex>
          <v-flex md6>
            <span style="font-size: 16px; font-weight: bold;">Laatste versies Pillarr</span>
          </v-flex>
          </v-layout>
          <v-layout row wrap class="ma-0 pa-0">
          <v-flex md6 style="font-size: 12px;">
            <span style="font-size: 14px; font-weight: bold;">Major</span> - <span style="font-size: 14px;"><strong>1</strong>.2.5</span><br>
            Ingrijpende aanpassing zoals:<br>
            -Toevoeging van nieuwere en betere API's<br>
            -Afschrijving van verschillende functies<br><br>
            <span style="font-size: 14px; font-weight: bold;">Minor</span> - <span style="font-size: 14px;">1.<strong>2</strong>.5</span><br>
            Kleinere aanpassing zoals:<br>
            -Release van nieuwe functionaliteit(en)<br><br>
            <span style="font-size: 14px; font-weight: bold;">Release</span> - <span style="font-size: 14px;">1.2.<strong>5</strong></span><br>
            Aanpassing zoals:<br>
            -Kleine aanpassingen of verbeteringen<br>
            -Bugfixes
          </v-flex>

          <v-flex md6 style="font-size: 11px;">
            <div v-for="(version, index) in versions" :key="index" class="software-version">
              <span class="software-version-number">{{version.version}}</span>
              <span class="software-version-date">{{version.date}}</span>
              <span class="software-version-author">{{version.author}}</span>
            </div>

          </v-flex>
        </v-layout>
      </v-container>

      <v-textarea
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        :label="`${selectedContentType} intro` "
        v-model="newNews.intro"
        counter="150"
        rows="3"
        no-resize
        >
      </v-textarea>

      <div v-if="newNews.type != 'update'" class="upload-news-image-wrapper clear">
        <div class="upload-image">
          <p>Upload afbeelding</p>
          <div v-if="newNews.imageUrl" class="logo-upload-preview">
            <v-img 
              :src="newNews.imageUrl"
              aspect-ratio="1"
              class="grey lighten-2"
              >
              <template v-slot:placeholder>
                <v-layout
                  fill-height
                  align-center
                  justify-center
                  ma-0
                >
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
            <div v-if="uploading == true" class="upload-bar">
              <p>{{ uploadProgress }} %</p>
              <div class="upload-bar-inner" v-bind:style="{ backgroundColor: companyPrimaryColor  }"></div>
            </div>
          </div>
          <v-btn class="ma-0" raised :color="companyPrimaryColor" dark @click="onFileSelect">Kies afbeelding</v-btn>
          <input
            type="file"
            style="display: none;"
            ref="fileInput"
            accept="image/*"
            @change="onFilePicked">
        </div>
      </div>

      <div class="field-wrapper" style="max-width: 100%; overflow: hidden;">
        <v-tooltip right>
          <template v-slot:activator="{on}">
            <label class="custom-label">{{selectedContentType}}  <v-icon v-on="on" small right :color="companyPrimaryColor" >help</v-icon></label>
          </template>
          <span style="color: #fff;">Omschrijving van {{selectedContentType}} voor gebruikers.</span>
        </v-tooltip>
        <ckeditor type="classic"  v-model="newNews.description" :config="editorConfig" :upload-adapter="UploadAdapter"></ckeditor>   
      </div>

      <div class="field-wrapper" style="margin: 0 0 15px 0; max-width: 100%; overflow: hidden;">
        <v-tooltip right>
          <template v-slot:activator="{on}">
            <label class="custom-label">Interne opmerkingen <v-icon v-on="on" small right :color="companyPrimaryColor" >help</v-icon></label>
          </template>
          <span style="color: #fff;">Extra informatie of uitleg voor intern gebruik.</span>
        </v-tooltip>
        
        <ckeditor type="classic"  v-model="newNews.extra" :config="editorConfig" :upload-adapter="UploadAdapter"></ckeditor>   
      </div>

      <v-text-field
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        v-if="newNews.type == 'update'"
        style="margin: 0 0 15px 0;"
        label="Auteur Update"
        v-model="newNews.updateAuthor"
        :rules="requiredRules"
        hint="Wie heeft de update gedaan?"
        persistent-hint
        required
      >
      </v-text-field>

      <v-menu
        ref="dateDialog"
        :close-on-content-click="false"
        v-model="publishDateDialog"
        transition="scale-transition"
        max-width="290px"
        min-width="290px"
        >
        <template v-slot:activator="{on}">
          <v-text-field
            outlined
            :color="companyPrimaryColor"
            v-on="on"
            v-model="publishDateFormatted"
            label="Datum"
            hide-details
            readonly
          ></v-text-field>
        </template>
        <v-date-picker
          :color="companyPrimaryColor"
          v-model="newNews.publishDate"
          :max="today"
          :show-current="true"
          no-title
          @input="publishDateDialog = false"
        ></v-date-picker>
      </v-menu>

      <v-text-field
        class="mt-4"
        hide-details
        outlined
        :color="companyPrimaryColor"
        style="margin: 15px 0;"
        type="number"
        label="Aantal fictieve likes"
        v-model.number="newNews.fictionalLikes"
        v-on:input="createFictionalLikes()"
        hint="Fictieve likes toevoegen om bericht imposanter te doen liken."
        persistent-hint
        >
      </v-text-field>

      <v-switch
        :color="companyPrimaryColor"
        v-model="newNews.published"
        class="pa-0"
        hide-details
      >
        <template slot='label'>
          <span style="color: #333; margin-right: 5px;">Publiceren</span>
          <v-tooltip class="ma-0 pa-0" right >
            <template v-slot:activator="{on}">
              <v-icon v-on="on" small :color="companyPrimaryColor">help</v-icon>
            </template>
            <span style="color: #fff;">Bericht wordt alleen getoond aan gebruikers als deze gepubliceerd is.</span>
          </v-tooltip>
        </template>
      </v-switch>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeAddNewsDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              :color="companySecondaryColor"
              @click="addNews()"
              >
              {{selectedContentType}} toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
      
  </v-card>
</template>


<script>
import db from "../../firebase/init";
import firebase from "firebase/app";;
import { Chrome } from "vue-color";
import platform from 'platform'; 
import moment from 'moment'; 

export default {
  name: "add-news-form",
  props: {
    versions: Array
  },

  data() {
    return {
      editorConfig: {
        toolbar: ['heading', 'bold', 'italic', 'bulletedList', 'numberedList',  '|', 'link' , 'ImageUpload',  '|', 'insertTable', "|", 'undo', "redo"],
        table: {
          contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        },
      },
      today: null,
      publishDateDialog: false,
      valid: false,
      newNews: {
        title: null,
        intro: null,
        type: "news",
        showTo: "all",
        version: null,
        published: true,
        description: "",
        fictionalLikes: 0,
        updateAuthor: null,
        publishDate: null,
        imageUrl: null,
        extra: "",
        views: [],
        likes: []
      },
      requiredRules: [v => !!v || "Dit veld is verplicht"],
      valid: true,
      filename: null,
      image: null,
      showTo: [
        {
          name: "Iedereen",
          id: "all" 
        },
        {
          name: "Kappers",
          id: "kapper"
        },
        {
          name: "Anders",
          id: "other"
        }
      ],
      newsTypes: [
        {
          name: "Nieuwsbericht",
          id: "news"
        },
        {
          name: "Tip",
          id: "tip"
        },
        {
          name: "Succesverhaal",
          id: "casestudie"
        },
        {
          name: "Actie",
          id: "action"
        },
        {
          name: "Software update",
          id: "update"
        },
      ],
      feedback: null,
      uploading: false,
      uploadProgress: null,
      file: {}
    };
  },

 
  created(){
    // Datum van vandaag alvast invullen al publicatiedatum en vandaag als de maximale datum zetten
    this.today = moment().format("YYYY-MM-DD");
    this.newNews.publishDate = moment().format("YYYY-MM-DD");
  },

  methods: {
    closeAddNewsDialog() {
      // Dialog sluiten en waardes resetten
      this.$emit("newNewsDialogChange", false);
      this.newNews =  {
        title: null,
        type: "news",
        showTo: "all",
        version: null,
        intro: null,
        fictionalLikes: 0,
        description: "",
        published: true,
        updateAuthor: null,
        publishDate: null,
        imageUrl: null,
        extra: "",
        views: [],
        likes: []
      }
      this.feedback = null
    },

    createTitle(){
      // Titel zelf genereren als het type een software update is.
      this.newNews.title = "Pillarrr versie " + this.newNews.version
    },

    onFileSelect() {
      // Openen van selectievenster in browser
      this.$refs.fileInput.click();
    },
   
    onFilePicked(event) {
      // Afbeelding selecteren
      const files = event.target.files;
      this.file = files[0];
      let filename = files[0].name;
      this.filename = filename;
      console.log("files: " + filename);
      if (filename.lastIndexOf(".") <= 0) {
        this.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.newNews.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
      this.feedback = null;
    },

    createFictionalLikes(){
      // Fictive likes creeren
      this.newNews.likes = _.times(this.newNews.fictionalLikes , _.constant("fictionalLike"))
    },

    UploadAdapter(loader){
      let token = Math.random().toString(36).substr(2);
      this.loader = loader
      
      let company = "hogans"
      let imageUrl = ""
      loader.file.then(response => {
        this.upload = () => {
          return new Promise((resolve, reject) => {
            const file = response;
            const filename = response.name;

            const ext = filename.slice(filename.lastIndexOf("."));
            const fileUrl = "wysiwyg/" + filename + "-" + token + ext;

            let uploadTask = firebase
              .storage()
              .ref(fileUrl)
              .put(file);

            uploadTask.on(
              "state_changed",
              taskSnapshot => {
              },
              error => {
                console.error(error);
                reject();
              },
              () => {
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(url => {
                    imageUrl = url
                    resolve();
                  })
                  .catch(error => {
                    reject();
                  });
              }
            );
          }).then(()=>{
            return {
              default: imageUrl
            }
          })
        }
      })
    },

    

    addNews(){
      // Nieuws toevoegen
      this.feedback = null
      if(this.newNews.type == 'update'){
        // type is software update. Afbeelding is niet nodig. 
        if(this.newNews.version && this.newNews.intro && this.newNews.description && this.newNews.updateAuthor && this.newNews.publishDate){
          db.collection("news").add({
            type: this.newNews.type,
            title: this.newNews.title,
            intro: this.newNews.intro,
            description: this.newNews.description,
            extra: this.newNews.extra,
            likes: this.newNews.likes,
            showTo: this.newNews.showTo,
            imageUrl: "https://firebasestorage.googleapis.com/v0/b/dev-app-137723.appspot.com/o/code-bg-pillarrr.png?alt=media&token=f9e162e3-4e79-4f48-9843-961f9746f1fc",
            views: [],
            fictionalLikes: Number(this.newNews.fictionalLikes),
            version: this.newNews.version,
            published: this.newNews.published,
            updateAuthor: this.newNews.updateAuthor, 
            publishDate: new Date(this.newNews.publishDate),
            user: this.userFirstName + " " + this.userLastName
          })
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + ' ' + platform.version, 
              action: "Pillarrr update " + this.newNews.version + " toegevoegd",
              extra:
                "<b>Versie</b>: " +
                this.newNews.version +
                "<br>" +
                "<b>Omschrijving</b>: " +
                this.newNews.intro + "<br> " +
                this.newNews.description +
                "<br>" +
                "<b>Extra</b>: " +
                this.newNews.extra +
                "<br>" +
                "<b>Gepubliceerd</b>: " +
                this.newNews.published
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeAddNewsDialog();
            console.log(this.selectedContentType + " succesfully added");
          })
        } else {
          this.feedback = "Vul alle velden in om een software update toe te voegen."
        }
      } 
      else {
        // type is geen software update. Afbeelding is dus verplicht. 
        if(this.newNews.imageUrl && this.newNews.description && this.newNews.intro && this.newNews.title && this.newNews.publishDate){
          db.collection("news").add({
            type: this.newNews.type,
            title: this.newNews.title,
            intro: this.newNews.intro,
            description: this.newNews.description,
            extra: this.newNews.extra,
            likes: this.newNews.likes,
            views: [],
            fictionalLikes: this.newNews.fictionalLikes,
            published: this.newNews.published,
            publishDate: new Date(this.newNews.publishDate),
            user: this.userFirstName + " " + this.userLastName
          })
          .then(async(docRef) => {
            if (this.filename) {
              await this.uploadNewsImage(docRef.id);
            }
          })
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Pillarrr nieuws toegevoegd: " + this.newNews.title,
              software: String(platform.os),
              browser: platform.name + ' ' + platform.version, 
              extra:
                "<b>Type</b>: " +
                this.newNews.type +
                "<br>" +
                "<b>Omschrijving</b>: " +
                this.newNews.intro + "<br> " +
                this.newNews.description +
                "<br>" +
                "<b>Extra</b>: " +
                this.newNews.extra +
                "<br>" +
                "<b>Gepubliceerd</b>: " +
                this.newNews.published
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeAddNewsDialog();
            console.log(this.selectedContentType + " succesfully added");
          })

        } else {
          this.feedback = "Vul alle velden in om een " + this.selectedContentType + " toe te voegen."
        }
      }
    },

    uploadNewsImage(docId) {
      // Afbeelding uploaden en News doc updaten
      return new Promise((resolve, reject) => {
        console.log("start storen");
        const file = this.file;
        const filename = this.filename;
        const ext = filename.slice(filename.lastIndexOf("."));
        const fileUrl =  "newsimages/" + docId + ext;
        this.uploading = true;
        let uploadTask = firebase
          .storage()
          .ref(fileUrl)
          .put(file);

        uploadTask.on(
          "state_changed",
          taskSnapshot => {
            var progress = Math.ceil((taskSnapshot.bytesTransferred / taskSnapshot.totalBytes) * 100);
            this.uploadProgress = progress;
          },
          error => {
            console.log(error);
            reject();
          },
          () => {
            console.log("The upload is compleet");
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(url => {
                db.collection("news")
                  .doc(docId)
                  .update({
                    imageUrl: url
                  })
                  .then(() => {
                    resolve();
                    this.uploading = false;
                    this.uploadProgress = null;
                  })
                  .catch(error => {
                    reject();
                    this.uploading = false;
                    this.uploadProgress = null;
                  });
              })
              .catch(error => {
                reject();
                this.uploading = false;
                this.uploadProgress = null;
              });
          }
        );
      });
    },

    formatDate(date) {
      // Datum omvormen naar Europese leesbare datum
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    }
  },

  computed: {
    selectedContentType(){
      // Naam van de geselecteerde contenttype
      let contentType
      this.newsTypes.map(type => {
        if(type.id == this.newNews.type){
          contentType = type.name
        }
      })
      return contentType
    },   

    publishDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.formatDate(this.newNews.publishDate);
    },

    update(){
      // Is de geselecteerde contenttype een update? Dite wordt gebruikt voor de disable prop in de title
      if(this.newNews.type == 'update'){
        return true
      } else{
        return false
      }
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    }
  }
};
</script>

<style>
.custom-label{
  font-size: 16px;
  padding: 15px 0 5px;
  display: inline-block;
}

.upload-news-image-wrapper{
  padding: 20px 0;
}

.software-version-number{
  width: 35px;
  display: inline-block;
  margin: 4px 4px 4px 0;
  font-size: 14px;
  font-weight: bold;
}


.software-version-date{
  display: inline-block;
  font-size: 12px;
  width: 120px;
}
.software-version-author{
  display: inline-block;
  font-size: 12px;
  width: 110px;
}

</style>
